import React, {
  LegacyRef,
  MouseEvent,
  forwardRef,
  useEffect,
  useRef,
  useState,
} from 'react';

import { Tooltip } from '@/design-system';
import { cn } from '@/utils/tailwind';

type TProps = {
  label: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  className?: string;
  disabled?: boolean;
  withoutTooltip?: boolean;
};

const Chip = forwardRef(
  (
    {
      label,
      leftIcon,
      rightIcon,
      onClick,
      className,
      withoutTooltip = false,
      disabled = false,
    }: TProps,
    ref
  ) => {
    const textRef = useRef<HTMLSpanElement | null>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      if (textRef.current) {
        setIsTruncated(
          textRef.current.scrollWidth > textRef.current.clientWidth
        );
      }
    }, [name]);
    return (
      <div
        ref={ref as LegacyRef<HTMLDivElement>}
        className={cn(
          'flex flex-row items-center gap-1 rounded-full border-[1px] border-brand-subtle px-[6px] py-[2px]',
          onClick && 'cursor-pointer hover:opacity-70',
          disabled && 'opacity-50',
          className
        )}
        onClick={disabled ? undefined : onClick}
      >
        {leftIcon}
        {!withoutTooltip && (
          <Tooltip title={isTruncated ? label : undefined}>
            <span
              className={cn('text-xs font-medium text-secondary', className)}
              ref={textRef}
            >
              {label}
            </span>
          </Tooltip>
        )}
        {rightIcon}
      </div>
    );
  }
);

export default Chip;
